exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer[data-v-4575fb75]{display:flex;position:fixed;bottom:0;width:100%;text-align:center;border-top:1px solid #d6d5d5;padding:5px;background:#fff;z-index:999}.footer li[data-v-4575fb75]{width:33.33%}.footer li a[data-v-4575fb75]{text-decoration:none;color:#9b9b9b}.footer li a.active[data-v-4575fb75]{color:#268e87}.footer li i[data-v-4575fb75]{font-size:25px}.footer li p[data-v-4575fb75]{font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4575fb75","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/footer.vue
// module id = 34
// module chunks = 0